import React from 'react';
import PropTypes from 'prop-types';
import JourneyStepProp from '../../../journey/propTypes/journeyStepProp';
import { JOURNEY_STEP_TYPE } from '../../../../services/utilityFunctions';
import CourseIcon from '../../../journey/overall/carousel/icons/CourseIcon';
import ChallengeIcon from '../../../journey/overall/carousel/icons/ChallengeIcon';
import SurveyIcon from '../../../journey/overall/carousel/icons/SurveyIcon';
import TaskIcon from '../../../journey/overall/carousel/icons/TaskIcon';
import ProfileIcon from '../../../journey/overall/carousel/icons/ProfileIcon';

const journeyStepIcon = step => {
  switch (step.type) {
    case JOURNEY_STEP_TYPE.COURSE:
      return <CourseIcon id={step._id} />;
    case JOURNEY_STEP_TYPE.GAME:
      return <ChallengeIcon id={step._id} />;
    case JOURNEY_STEP_TYPE.SURVEY:
      return <SurveyIcon id={step._id} />;
    case JOURNEY_STEP_TYPE.TASK:
      return <TaskIcon id={step._id} />;
    default:
      return <ProfileIcon id={step._id} />;
  }
};

export default function JourneyBannerNextStep({ t, step }) {
  return (
    <div className="journey-next-step">
      <h6>{t('journey_nextStep')}</h6>
      <div className="journey-next-step-info">
        {journeyStepIcon(step)}
        <div className="journey-next-step-title-progress">
          <h5>{t(`journey_stepType_${step.type}`)}</h5>
        </div>
      </div>
    </div>
  );
}

JourneyBannerNextStep.propTypes = {
  t: PropTypes.func.isRequired,
  step: PropTypes.shape(JourneyStepProp.propType).isRequired,
};
